import Vue from 'vue'
import Vuex from 'vuex'
import mutation from './mutation'

Vue.use(Vuex)

export function createStore() {
        return new Vuex.Store({
                state: mutation.state,
                actions: mutation.actions,
                mutations: mutation.mutations,
        })
}